export default function replaceUndefinedWithNull(val: any): any {
  if (typeof val === 'undefined') {
    return null;
  }

  if (val instanceof Array) {
    return val.map(replaceUndefinedWithNull);
  }

  if (typeof val === 'object' && val != null) {
    return Object.entries(val).reduce<Record<string, unknown>>(
      (result, [key, value]) => {
        result[key] = replaceUndefinedWithNull(value);

        return result;
      },
      {}
    );
  }

  return val;
}
